import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';

const mapState = state => ({
  messageFromState: state.async.message,
  show: state.async.show
});

const LoadingComponent = ({ inverted, message, messageFromState, show }) => {
  return (
    <React.Fragment>
      {show && (
        <Dimmer inverted={inverted} active={true}>
          <Loader content={messageFromState || message || 'Loading . . .'} />
        </Dimmer>
      )}
    </React.Fragment>
  );
};

export default connect(mapState)(LoadingComponent);
